// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1UAq6","question":"Question_question__1jTGt","description":"Question_description__2ts9W"};